import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosCall, AxiosPost } from '../../utils/axios';
import * as actions from './actions';

function* fetchStore() {
  try {
    const result = yield call(AxiosCall, '/payments/get_memberships/');
    yield put(actions.fetchStoreSuccess(result.data.response));
  } catch (e) {
    yield put(actions.fetchStoreFailure(e));
  }
}

function* checkoutOnetime(action) {
  try {
    const { email, price_id, product_name } = action.payload;
    const result = yield call(AxiosPost, '/payments/create_checkout_onetime/', {
      email,
      price_id,
      product_name,
    });
    yield put(actions.checkoutOnetimeSuccess(result.data.response));
    window.location.href = result.data.response;
  } catch (e) {
    yield put(actions.checkoutOnetimeFailure(e));
  }
}

export default function* publicStoreSaga() {
  yield all([
    takeLatest(actions.FETCH_STORE_REQUEST, fetchStore),
    takeLatest(actions.CHECKOUT_ONETIME_REQUEST, checkoutOnetime),
  ]);
}
